import { Component, OnInit } from '@angular/core';
import { CstemapiService } from '../cstemapi.service';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-chooseoptions',
  templateUrl: './chooseoptions.component.html',
  styleUrls: ['./chooseoptions.component.scss']
})
export class ChooseoptionsComponent implements OnInit {
  plantDesign: any;
  application: any;
  miniGrid: any;
  financial: any;
  technology: any;
  tracking: any;
  
  constructor(private myRoute: Router, public cstemapi: CstemapiService, private auth: AuthService) { 
    this.plantDesign = "1";
    this.application = "1";
    this.financial = "1";
    this.technology = "1";
    this.tracking = '1';

    this.auth.setIsGuest('false')
  }

  ngOnInit() {
  }

  finalselections() {
    var coptions = {
      plantDesign: this.plantDesign,
      application: this.application,
      financial: this.financial,
      technology: this.technology,
      tracking: this.tracking
    }
    if(this.application == 2) {
      coptions['minigrid'] = this.miniGrid;
    }
    this.auth.saveOptions(coptions);

    // this.myRoute.navigate(['/areaselection']);
    this.myRoute.navigate(['/appinfo']);
  }

  applicationChange() {
    if(this.application == '2') {
      this.miniGrid = '1';
      this.technology = '2';
      this.financial = '1';
    } else {
      this.miniGrid = undefined;
      this.technology = '1';
      this.financial = '1';
    }
  }

  // technologyChange() {
  //   if(this.technology == '3') {
  //     this.tracking = '1';
  //   } else {
  //     this.tracking = undefined;
  //   }
  // }
}
